import { selectIsPreviewMode } from '@/redux/customisation/selector'
import { useTranslate } from '@tolgee/react'
import { FC, ReactNode, useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'

interface ExternalContentProps {
  children: ReactNode
}

const ExternalContent: FC<ExternalContentProps> = ({ children }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const { t } = useTranslate()
  const isPreviewMode = useSelector(selectIsPreviewMode)

  useEffect(() => {
    const onHrefClickInPreviewMode = (e: MouseEvent) => {
      // TODO: this does not work since target element could be a child element nested inside <a>
      const target = e.target as HTMLElement
      if (target.tagName.toLowerCase() === 'a') {
        e.preventDefault()
        if (
          window.confirm(
            t(
              'This link cannot be opened in customisation preview. It will be opened in a new window ({target}).\nClick OK to continue',
              { target: target.getAttribute('href') }
            )
          )
        ) {
          window.open(target.getAttribute('href') || '', '_blank')
        }
      }
    }

    if (isPreviewMode && containerRef.current) {
      containerRef.current.addEventListener('click', onHrefClickInPreviewMode)
    }

    return () => {
      if (isPreviewMode && containerRef.current) {
        containerRef.current.removeEventListener(
          'click',
          onHrefClickInPreviewMode
        )
      }
    }
  }, [isPreviewMode, t])

  return <div ref={containerRef}>{children}</div>
}

export default ExternalContent
